// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"16950243","732":"bbfb3d4c","977":"d85da3fe"}[chunkId] + ".chunk.js";
};